import { Dialog, DialogContent, DialogTitle, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import Controls from './Controls';

const useStles = makeStyles((theme) => ({
  dialogWrapper: {
    padding: theme.spacing(2),
    position: 'absolute',
    top: theme.spacing(2)
  },
  dialogTitle: {
    paddingRight: '0px'
  }
}));

function Popup(props) {
  const { title, children, openPopup, setOpenPopup } = props;
  const classes = useStles();

  return (
    <Dialog open={openPopup} maxWidth="lg" classes={{ paper: classes.dialogWrapper }}>
      <DialogTitle className={classes.dialogTitle}>
        <div style={{ display: 'flex' }}>
          <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Controls.ActionButton
            color="secondary"
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            <CloseIcon />
          </Controls.ActionButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}

export default Popup;
